/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 */

import * as z from "zod/v4-mini";
import { remap as remap$ } from "../../lib/primitives.js";
import { safeParse } from "../../lib/schemas.js";
import { ClosedEnum } from "../../types/enums.js";
import { Result as SafeParseResult } from "../../types/fp.js";
import { SDKValidationError } from "../errors/sdkvalidationerror.js";
import {
  ExplainedAccessRule,
  ExplainedAccessRule$inboundSchema,
} from "./explainedaccessrule.js";

/**
 * The access being explained.
 */
export const Level = {
  Use: "use",
  View: "view",
  Manage: "manage",
} as const;
/**
 * The access being explained.
 */
export type Level = ClosedEnum<typeof Level>;

/**
 * For use: whether every tool, only some, or none are reachable.
 */
export const ToolAccess = {
  All: "all",
  Some: "some",
  None: "none",
} as const;
/**
 * For use: whether every tool, only some, or none are reachable.
 */
export type ToolAccess = ClosedEnum<typeof ToolAccess>;

export type ExplainedAccessLevel = {
  /**
   * Whether the rules give the member this access.
   */
  allowed: boolean;
  /**
   * The access being explained.
   */
  level: Level;
  /**
   * Every rule matching this access, deciding rules first.
   */
  rules: Array<ExplainedAccessRule>;
  /**
   * For use: whether every tool, only some, or none are reachable.
   */
  toolAccess?: ToolAccess | undefined;
};

/** @internal */
export const Level$inboundSchema: z.ZodMiniEnum<typeof Level> = z.enum(Level);

/** @internal */
export const ToolAccess$inboundSchema: z.ZodMiniEnum<typeof ToolAccess> = z
  .enum(ToolAccess);

/** @internal */
export const ExplainedAccessLevel$inboundSchema: z.ZodMiniType<
  ExplainedAccessLevel,
  unknown
> = z.pipe(
  z.object({
    allowed: z.boolean(),
    level: Level$inboundSchema,
    rules: z.array(ExplainedAccessRule$inboundSchema),
    tool_access: z.optional(ToolAccess$inboundSchema),
  }),
  z.transform((v) => {
    return remap$(v, {
      "tool_access": "toolAccess",
    });
  }),
);

export function explainedAccessLevelFromJSON(
  jsonString: string,
): SafeParseResult<ExplainedAccessLevel, SDKValidationError> {
  return safeParse(
    jsonString,
    (x) => ExplainedAccessLevel$inboundSchema.parse(JSON.parse(x)),
    `Failed to parse 'ExplainedAccessLevel' from JSON`,
  );
}
